// Case study data — external redirect only (case detail pages removed)
// Used by Trust section on landing and TrustBar on /start
export const caseStudies = {
  "donburi-house": {
    slug: "donburi-house",
    logo: "Donburi House",
    external_url: "https://donburihouse.it",
  },
};

export const caseOrder = ["donburi-house"];

// Extra tiles to fill the trust bar visually while remaining honest and NDA-safe
export const ndaPlaceholders = [
  { key: "nda-1", label: "Riservato NDA", label_en: "Under NDA" },
  { key: "nda-2", label: "Riservato NDA", label_en: "Under NDA" },
  { key: "nda-more", label: "+ 40 brand", label_en: "+ 40 brands" },
];
